export default "__VITE_ASSET__BDugmNGD__"